<template>
  <div v-show="showBtn" class="side-icons">
    <div class="circle-icon" :class="showBtn ? 'fadeIn' : 'fadeOut'" @click="toTop()">
      <i class="iconfont icon-fanhuidingbu" />
    </div>
  </div>
</template>

<script>
import topMixin from './topMixin'
export default {
  name: 'SideIcons',
  mixins: [topMixin],
  data() {
    return {
      showBtn: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.showBtn = scrollTop > 10
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables.scss';
.side-icons{
  right: 20px;
  bottom: 10%;
  z-index: 2001;
  position: fixed;
  transition: display .3s;
  .circle-icon{
    width: 50px;
    height: 50px;
    color: #fff;
    line-height: 50px;
    text-align: center;
    border-radius: 50%;
    background-color: rgba($color: #666, $alpha: .6);
  }
  .fadeIn{
    animation-name: fadeIn; //flash为要使用的动画效果名，在这里不需要加animate前缀
    animation-duration: 1s; //这里设定完成该动画的时间
  }
  .fadeOut{
    animation-name: fadeOut;
    animation-duration: 1s;
  }
}
</style>
